// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VNpY","placeholdersHeader":"styles_placeholdersHeader__gT8wJ","editorStyle":"styles_editorStyle__yd4wN","placeholdersBox":"styles_placeholdersBox__29Eev"};